// extracted by mini-css-extract-plugin
export default {"Inner":"WWUAFGePNJBA0_seRWlX","Heading":"TCpxq20heJlGBaSbNI4y","Content":"AXbF9ehRSXzzERBwn1XK","Variant--light":"cVALO6yJDjmV1Xvkvynu","Variant--dark":"rnHZet7H8f4I0eCy29lg"};